/** The mark is an interchange stop: one line comes in, three lines leave. */
export function LogoMark({ size = 30 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <path d="M2.5 16H10" stroke="var(--ink)" strokeWidth="3.5" strokeLinecap="round" />
      <path
        d="M21 16l4.5-7H30M21 16h9M21 16l4.5 7H30"
        fill="none"
        stroke="var(--cobalt)"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="8.5"
        y="10"
        width="15"
        height="12"
        rx="6"
        fill="var(--surface)"
        stroke="var(--ink)"
        strokeWidth="3"
      />
    </svg>
  );
}

export function Logo() {
  return (
    <span className="logo">
      <LogoMark />
      <span className="logo-word">LowCostRouter</span>
    </span>
  );
}
